export default __webpack_public_path__ + "static/media/Dinosaurs_13.6abb53be.png";